<template>
  <v-container fluid class="scrollable-content">
    <v-expansion-panels>
      <v-expansion-panel readonly>
        <v-expansion-panel-title expand-icon="">
          <v-row no-gutters>
            <v-col cols="8"> <strong>Provincia </strong> </v-col>
            <v-col cols="4"> </v-col>
          </v-row>
        </v-expansion-panel-title>
      </v-expansion-panel>
      <v-expansion-panel
        v-for="(e, i) in province"
        :key="i"
        readonly
        @click="select(e.long)"
      >
        <v-expansion-panel-title v-slot="{}" expand-icon="">
          <v-row no-gutters>
            <v-col cols="8">
              <v-fade-transition leave-absolute>
                <span key="0">{{ e.long }} </span>
              </v-fade-transition>
            </v-col>
            <v-col cols="4" class="text--secondary">
              <span key="0">{{ e.short }} </span>
            </v-col>
          </v-row>
        </v-expansion-panel-title>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useBookingStore } from "@/features/booking/store";

const bookingStore = useBookingStore();

const emit = defineEmits<{
  select: [provincia: string];
}>();

function select(provincia: string): void {
  emit("select", provincia);
}

const province = computed((): Array<{ long: string }> => {
  return bookingStore.Filiali.map((f) => f.Provincia)
    .filter((v, i, s) => s.indexOf(v) === i)
    .map((f) => {
      return { long: f };
    })
    .sort();
});
</script>

<style scoped>
.scrollable-content {
  height: calc(100vh - 180px);
  overflow-y: auto;
}
</style>
